import { c as _c } from "react/compiler-runtime";
import ViverseButton from '@/components/ViverseButton';
import IconDiamond from '@/components/assets/icon_diamond.svg';
import { usePremiumPlanDialogContext } from '@/context/PremiumPlanDialogContext';
import { cn } from '@/lib/utils';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';
import { useIsClient } from 'usehooks-ts';
export default function PremiumButton(t0) {
  const $ = _c(17);
  const {
    label,
    communityUserId,
    className,
    "data-component": dataComponent
  } = t0;
  const isClient = useIsClient();
  const router = useRouter();
  const pathname = usePathname();
  const {
    openDialog
  } = usePremiumPlanDialogContext();
  const [menuOpen, setMenuOpen] = useState(false);
  let t1;
  if ($[0] !== communityUserId || $[1] !== menuOpen || $[2] !== openDialog || $[3] !== pathname || $[4] !== router) {
    t1 = () => {
      setMenuOpen(!menuOpen);
      if (pathname.includes(`/profile/${communityUserId}`)) {
        openDialog();
      } else {
        router.push(`/profile/${communityUserId}?premium=true`);
      }
    };
    $[0] = communityUserId;
    $[1] = menuOpen;
    $[2] = openDialog;
    $[3] = pathname;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleClick = t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn("group min-w-fit gap-[4px]", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = !isClient;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconDiamond className="group-disabled:fill-vive-primary-60 size-[20px] shrink-0" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== label) {
    t5 = label && <p className="buttonS-omni-styles text-vive-primary-80">{label}</p>;
    $[9] = label;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dataComponent || $[12] !== handleClick || $[13] !== t2 || $[14] !== t3 || $[15] !== t5) {
    t6 = <ViverseButton className={t2} onClick={handleClick} variant="extra2" disabled={t3} data-component={dataComponent}>{t4}{t5}</ViverseButton>;
    $[11] = dataComponent;
    $[12] = handleClick;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}